const translations = {
  "en": {
    "Claim Founding Pass": "Claim Founding Pass",
    "Contact Us": "Contact Us",
    "Create Account": "Create Account",
    "Current Plan": "Current Plan",
    "or": "or",
    "Pay with crypto": "Pay with crypto",
    "Purchase failed. Please try again.": "Purchase failed. Please try again.",
    "Renew": "Renew",
    "Renew with crypto": "Renew with crypto",
    "Start with 7 days free trial": "Start 7-Day Free Trial",
    "Subscribe": "Subscribe",
    "Switch to v2 Plan": "Switch to v2 Plan",
    "Try 7 Days for %{var0}": "Try 7 Days for %{var0}",
    "Upgrade": "Upgrade"
  },
  "zh-tw": {
    "Claim Founding Pass": "領取創始會員",
    "Contact Us": "聯絡我們",
    "Create Account": "建立帳號",
    "Current Plan": "目前方案",
    "or": "或",
    "Pay with crypto": "使用加密貨幣支付",
    "Purchase failed. Please try again.": "購買失敗。請再試一次。",
    "Renew": "續訂",
    "Renew with crypto": "使用加密貨幣續訂",
    "Start with 7 days free trial": "開始 7 日免費試用",
    "Subscribe": "訂閱",
    "Switch to v2 Plan": "切換至 v2 方案",
    "Try 7 Days for %{var0}": "%{var0} 試用 7 天",
    "Upgrade": "升級"
  }
};

export default translations;
